// The assistant writes short answers with at most **bold** and simple lists. Everything is
// escaped first, so nothing the model (or a stored answer) contains can become markup.
function escapeHtml(text) {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function inline(text) {
  return escapeHtml(text).replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
}

export function renderChatMarkup(text, subClass = 'aic__sub') {
  const lines = String(text || '').replace(/\r\n/g, '\n').split('\n');
  const out = [];
  let list = null; // { tag, items }

  const flush = () => {
    if (list) {
      out.push(`<${list.tag}>${list.items.map((i) => `<li>${i}</li>`).join('')}</${list.tag}>`);
      list = null;
    }
  };

  lines.forEach((raw) => {
    const line = raw.trim();
    if (line === '') return; // blank lines between list items must not split the list
    const ordered = line.match(/^(\d+)[.)]\s+(.*)$/);
    const bullet = line.match(/^[-*•]\s+(.*)$/);
    if (bullet && list && list.tag === 'ol' && list.items.length) {
      // "- Dimensions: …" under a numbered item: keep it inside that item.
      list.items[list.items.length - 1] += `<br><span class="${subClass}">${inline(bullet[1])}</span>`;
      return;
    }
    if (ordered || bullet) {
      const tag = ordered ? 'ol' : 'ul';
      if (!list || list.tag !== tag) {
        flush();
        list = { tag, items: [] };
      }
      list.items.push(inline(ordered ? ordered[2] : bullet[1]));
      return;
    }
    flush();
    out.push(`<p>${inline(line)}</p>`);
  });
  flush();

  return out.join('');
}
